"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Foursquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Foursquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "FourSquare"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "foursquare",
    className: "cls-1",
    d: "M71.735,10H29.043c-5.86,0-7.8,4.422-7.8,7.2V84.992c0,3.172,1.89,4.328,2.844,4.7a4.814,4.814,0,0,0,5.141-1.109C49.373,65.24,49.717,64.849,49.717,64.849c.484-.531.531-.484,1.063-.484H63.812c5.485,0,6.345-3.938,6.923-6.2l7.594-37.973C79.657,13.563,77.985,10,71.735,10ZM69.188,21.532l-1.782,9.329a2.938,2.938,0,0,1-2.641,2.063H48.139A3.065,3.065,0,0,0,44.92,36.1v2.032a3.1,3.1,0,0,0,3.219,3.219H62.265a2.516,2.516,0,0,1,2.313,2.844C64.3,45.582,62.937,52.6,62.8,53.379a2.784,2.784,0,0,1-2.64,2.11H48.67c-2.109,0-2.688.281-4.141,1.969,0,0-1.391,1.781-13.986,16.923-.14.141-.281.094-.281-.047V21.392A2.678,2.678,0,0,1,32.856,18.8H67.078a2.211,2.211,0,0,1,2.11,2.734Z"
  })));
}